import { Compass, TrendingUp, MessagesSquare, PenTool, Camera, Clapperboard, ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { SERVICES } from "@/data/content";

const ICONS = { Compass, TrendingUp, MessagesSquare, PenTool, Camera, Clapperboard };

export default function Services() {
  return (
    <section id="servicos" className="bg-royal py-28 md:py-40" data-testid="services-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid gap-10 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <Reveal>
              <Overline light>Serviços</Overline>
              <h2 className="mt-6 font-display text-4xl font-medium leading-[1.05] tracking-tight text-white md:text-6xl">
                Tudo o que a tua marca precisa para <em>avançar.</em>
              </h2>
            </Reveal>
          </div>
          <div className="flex items-end lg:col-span-4 lg:col-start-9">
            <Reveal delay={0.2}>
              <p className="text-base leading-relaxed text-white/70">
                Cinco áreas pensadas para trabalhar em conjunto, para fazer a tua marca
                mover-se.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="mt-20 grid border-t border-l border-white/15 md:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <Reveal key={s.n} delay={(i % 3) * 0.1} className="h-full">
                <div
                  className="group relative flex h-full flex-col justify-between border-b border-r border-white/15 p-8 transition-colors duration-500 hover:bg-black/10 md:p-10"
                  data-testid={`service-card-${s.n}`}
                >
                  <div className="flex items-start justify-between">
                    <span className="font-display text-5xl font-medium text-white/20 transition-colors duration-500 group-hover:text-white/50 md:text-6xl">
                      {s.n}
                    </span>
                    <Icon
                      className="h-7 w-7 text-white/60 transition-all duration-500 group-hover:scale-110 group-hover:text-white"
                      strokeWidth={1.4}
                    />
                  </div>
                  <div className="mt-16">
                    <h3 className="flex items-center gap-2 font-display text-2xl font-medium text-white md:text-3xl">
                      {s.name}
                      <ArrowUpRight className="h-5 w-5 -translate-x-1 translate-y-1 opacity-0 transition-all duration-500 group-hover:translate-x-0 group-hover:translate-y-0 group-hover:opacity-100" />
                    </h3>
                    <p className="mt-4 text-sm leading-relaxed text-white/65">{s.desc}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
